import React from 'react'
import { Card, Row, Col } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import BoardElementSelected from './BoardElementSelected';
import PropTypes from 'prop-types';
import { Toggle } from '@fluentui/react';
import { useState } from 'react';
import CTextBox from '../../../../Common/CTextBox';
import { useOnSearchElementsConfig } from '../../../../../hooks/component/sKPI/useOfBoardElementsConfigBox';
import '../../../../../styles/css/RelatedConcept.css'
import { __OBJECT_STRUCTURE_GetList } from '../../../../../common/ObjectStructures/Trasnversal';

function BoardElementsConfigBox(props) {
    const { t } = useTranslation();

    //Parametros de entrada.
    const { 
        inputParam_EditMode = false,
        inputParam_ElementType = null, 
        inputParam_SelectedVariables = null,
        
        inputParam_ElementListBase = null,
        inputParam_SetElementsListBase = null,
    } = props;

    const [tglViewGridType, setTglViewGridType] = useState(false);
    const [searchManager, setSearchManager] = useState({text: "", fireSearch: false});
    const [listBoardElementsAux, setListBoardElementsAux] = useState(inputParam_ElementListBase);
    const [listBoardElementsGridAux, setListBoardElementsGridAux] = useState(__OBJECT_STRUCTURE_GetList(10, inputParam_ElementListBase));

    useOnSearchElementsConfig(searchManager, inputParam_ElementListBase, setSearchManager, setListBoardElementsAux, setListBoardElementsGridAux)

    const onViewTypeChange = () => {
        setTglViewGridType(!tglViewGridType)

        if (!tglViewGridType) {
            updatePorcionFromBase(listBoardElementsGridAux.data, inputParam_ElementListBase, inputParam_SetElementsListBase, false)
        }
        else {
            updatePorcionFromBase(inputParam_ElementListBase, listBoardElementsGridAux.data, setListBoardElementsGridAux, true)
        }
    }

    const updatePorcionFromBase = (listadoBase, listadoPorcion, setListadoPorcion, isGrid) => {
        const updatedPorcion = listadoPorcion.map(porcionElement => {
            const matchingBaseElement = listadoBase.find(
                baseElement => baseElement.id === porcionElement.id
            );

            if (matchingBaseElement) {
                return {
                    ...porcionElement,
                    'nRoles': matchingBaseElement.nRoles,
                    'nVariables': matchingBaseElement.nVariables
                };
            }

            return porcionElement;
        });

        if (isGrid) {
            setListadoPorcion(prevState => ({
                ...prevState,
                data: updatedPorcion,
                fireUpdate: true
            }));
        }
        else {
            setListadoPorcion(updatedPorcion);
        }
    };

    const onSearch = (controlValue) => {
        if (controlValue === "") {
            setListBoardElementsAux(inputParam_ElementListBase);
            setListBoardElementsGridAux(prevState => ({
                ...prevState,
                fireUpdate: true,
                data: inputParam_ElementListBase
            }));
            
            setSearchManager({ text: controlValue, fireSearch: false })
        }
        else {
            setSearchManager({ text: controlValue, fireSearch: true })
        }
    };

    return (
        <Card className='board-element-form'>
            <Row>
                <Col>
                    <Card.Header className="card-header-compact">
                        <Card.Title className="d-flex justify-content-between">
                            <b>{ t('data-lang-boxname-elements') }</b>
                                {
                                    inputParam_ElementListBase !== null &&
                                    <div className='toolbar d-flex'>
                                            <div className='mb-2 me-3 d-flex' style={{fontSize: "14px"}}>
                                                <div className='mt-2 me-2'>{t('data-lang-lbl-search')}:</div>
                                                <CTextBox controlValue={searchManager.text} setterControlValue={onSearch} />
                                            </div>
                                            <div className='mt-2'>
                                                <Toggle
                                                    checked={ tglViewGridType }
                                                    onChange={ onViewTypeChange }
                                                    role="checkbox"
                                                    onText={ t('data-lang-lbl-grid') }
                                                    offText={ t('data-lang-lbl-box')}
                                                    styles={ {root:{float: "right", display: "flex"}, label: {marginRight : "5px"}} }
                                                />
                                            </div>
                                    </div>
                                }
                        </Card.Title>
                    </Card.Header>
                    <Card.Body className="board-element-form-body pt-2 w-100" style={{height: "800px", overflowY: 'scroll'}}>
                        <Row className='h-100'>
                            {
                                inputParam_ElementListBase && !tglViewGridType && (listBoardElementsAux !== null ? listBoardElementsAux : inputParam_ElementListBase).map((element, index) => 
                                    <Col className={`mb-2`} key={ index } xs={12} sm={12} md={6} lg={6} xl={6} xxl={6}>
                                        <BoardElementSelected
                                            key={ index }
                                            inputParam_Index={ index }

                                            inputParam_ElementItem={ element }
                                            inputParam_ElementType={ inputParam_ElementType }

                                            inputParam_EditMode={ inputParam_EditMode }
                                            inputParam_SelectedVariables={inputParam_SelectedVariables}

                                            inputParam_TglViewGridType={tglViewGridType}

                                            inputParam_ElementListBase={ inputParam_ElementListBase }
                                            inputParam_SetBoardElementsBase={inputParam_SetElementsListBase}

                                            inputParam_ElementList={ listBoardElementsAux }
                                            inputParam_SetElementList={setListBoardElementsAux}

                                            inputParam_ElementListGrid={ null }
                                            inputParam_SetBoardElementsGrid={ null }

                                        />
                                    </Col>
                                )
                            }
                            {
                                inputParam_ElementListBase && tglViewGridType &&
                                <Col className={`mb-2`} xs={12} xxl={12}>
                                    <BoardElementSelected
                                        inputParam_Index={ -1 }

                                        inputParam_ElementItem={ {} }
                                        inputParam_ElementType={ inputParam_ElementType }

                                        inputParam_EditMode={ inputParam_EditMode }
                                        inputParam_SelectedVariables={inputParam_SelectedVariables}

                                        inputParam_TglViewGridType={tglViewGridType}

                                        inputParam_ElementListBase={ inputParam_ElementListBase }
                                        inputParam_SetBoardElementsBase={inputParam_SetElementsListBase}

                                        inputParam_ElementList={ listBoardElementsAux }
                                        inputParam_SetElementList={setListBoardElementsAux}
                                        inputParam_ElementListGrid={ listBoardElementsGridAux.data !== null ? listBoardElementsGridAux : [] }
                                        inputParam_SetBoardElementsGrid={setListBoardElementsGridAux}
                                    />
                                </Col>
                            }
                        </Row>
                    </Card.Body>
                    <Card.Footer>
                    </Card.Footer>
                </Col>
            </Row>
        </Card>
    );
}

BoardElementsConfigBox.propTypes = {
    inputParam_EditMode: PropTypes.bool.isRequired,
    inputParam_ElementType: PropTypes.number,

    inputParam_ElementListBase: PropTypes.array,
    inputParam_SetElementsListBase: PropTypes.func.isRequired,

    inputParam_SelectedVariables: PropTypes.array,
  };

export default BoardElementsConfigBox;